import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { ROLES } from 'common/constants';
import { useClient } from 'components/ClientProvider';
import { setErrorMessages } from 'components/ErrorMessageHandler/slice';
import { messages } from 'pages/LandingPage/messages';
import { setUserRole, getIsLoginFailed } from 'pages/LandingPage/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getUserRole } from 'utils';

export const useLoginHandler = (): (() => void) => {
  const userInfo = useClient();
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const isLoginFailed = useAppSelector(getIsLoginFailed);
  const userRole = getUserRole(userInfo?.customClientValues?.permissions);
  return useCallback(() => {
    if (userRole !== ROLES.UNAUTHORIZED) dispatch(setUserRole(userRole));
    if (isLoginFailed)
      dispatch(
        setErrorMessages([intl.formatMessage(messages.unauthorizedUserMessage)])
      );
  }, [userRole, dispatch, intl, isLoginFailed]);
};
